var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.8125V2.375C12.25 1.41797 11.457 0.625 10.5 0.625H2.625C1.14844 0.625 0 1.80078 0 3.25V10.25C0 11.7266 1.14844 12.875 2.625 12.875H12.25C13.207 12.875 14 12.1094 14 11.125V4.5625C14 3.60547 13.207 2.8125 12.25 2.8125ZM12.6875 11.125C12.6875 11.3711 12.4688 11.5625 12.25 11.5625H2.625C1.88672 11.5625 1.3125 10.9883 1.3125 10.25V3.25C1.3125 2.53906 1.88672 1.9375 2.625 1.9375H10.5C10.7188 1.9375 10.9375 2.15625 10.9375 2.375V3.25H3.0625C2.81641 3.25 2.625 3.46875 2.625 3.6875C2.625 3.93359 2.81641 4.125 3.0625 4.125H12.25C12.4688 4.125 12.6875 4.34375 12.6875 4.5625V11.125ZM10.5 6.75C10.0078 6.75 9.625 7.16016 9.625 7.625C9.625 8.11719 10.0078 8.5 10.5 8.5C10.9648 8.5 11.375 8.11719 11.375 7.625C11.375 7.16016 10.9648 6.75 10.5 6.75Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ccb81e80.svg";
export { ForwardRef as ReactComponent };